import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { db } from '../firebase';

function useFiles(user, projectId) {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user || !projectId) {
      setFiles([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const filesRef = collection(db, 'project_files');
      const q = query(
        filesRef,
        where('project_id', '==', projectId),
        orderBy('created_at', 'desc')
      );

      const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
          const filesData = [];
          snapshot.forEach((doc) => {
            filesData.push({
              id: doc.id,
              ...doc.data()
            });
          });
          setFiles(filesData);
          setLoading(false);
        },
        (err) => {
          console.error('Error fetching files:', err);
          setError(err.message);
          setLoading(false);
        }
      );

      return () => unsubscribe();
    } catch (err) {
      console.error('Error setting up files listener:', err);
      setError(err.message);
      setLoading(false);
    }
  }, [user, projectId]);

  return { files, loading, error, setFiles };
}

export default useFiles;